export const weatherCodeParameterName = "weather_code";
export const wwCodeCloudName = "total_cloud_cover_mean_";
export const DefaultWwCodeCloudParameter = "total_cloud_cover_mean_1h:octas";
export const DefaultSymbolIconOpacity = 1;
